/**
 * Hook to check if a company portal subdomain is valid and enabled.
 * Used when the app detects a company-type subdomain.
 */
import { useQuery } from 'react-query';
import { portalApi } from '../services/companyApi';
import type { PortalInfo } from '../types';

export const usePortalInfo = (subdomain: string | null) => {
  return useQuery<PortalInfo, Error>(
    ['portal', subdomain],
    () => portalApi.getPortalInfo(subdomain!),
    {
      enabled: !!subdomain,
      retry: false,
      staleTime: 5 * 60 * 1000, // 5 min cache
      cacheTime: 10 * 60 * 1000,
    }
  );
};
